// client/src/components/Spinner.jsx
// Centered loader used while /api/me boots and on big async screens.
// Uses three brand-colour rings rotating at different speeds so the
// loader feels alive without going full pinwheel.

export default function Spinner({ label }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8 text-ink-500">
      <div className="relative w-12 h-12">
        <span className="absolute inset-0 rounded-full border-[3px] border-brand-200" />
        <span className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-brand-600 animate-spin" />
        <span
          className="absolute inset-1.5 rounded-full border-[3px] border-transparent border-t-joy-500 animate-spin"
          style={{ animationDuration: '1.4s', animationDirection: 'reverse' }}
        />
      </div>
      {label && <div className="text-sm font-medium">{label}</div>}
    </div>
  );
}
